import styled from '@emotion/styled';
import { MicrophoneIcon, BellIcon, YoutubeIcon } from '@seedlang/icons';
import { isPresent } from '@seedlang/utils';
import NotificationMessage from 'components/notification/notification_message';
import Paginator from 'components/paginator';
import Text from 'components/text';
import { observer } from 'mobx-react';
import React from 'react';
import Link from 'components/link';
import UserProfileImage from 'components/user/user_profile_image';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.div`
`;

const Notification = styled.div`
  background: ${props => props.background};
  display: flex;
  align-items: flex-start;
  padding: 5px;
  font-size: 14px;
  line-height: 18px;
  border-bottom: 1px solid #CCC;
  text-align: left;
  a {
    display: flex;
    align-items: flex-start;
    flex: 1;
    color: inherit;
    text-decoration: none;
  }
`;

const MessageWrapper = styled.div`
  flex: 1;
`;

const PaginatorWrapper = styled.div`
  padding: 0 5px 5px 5px;
`;

const ImageWrapper = styled.div`
  padding-left: 4px;
  margin-right: 8px;
  display: flex;
  align-items: flex-start;
  margin-top: 2px;
`;

const IconCircle = styled.div`
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background: ${props => props.background || '#dddddd'};
  display: flex;
  align-items: center;
  justify-content: center;
  padding-right: 0.5px;
  .icon-wrapper {
    width: 16px;
    height: 16px;
    .icon {
      width: 16px;
      height: 16px;
      svg {
        fill: #333;
        width: 16px;
        height: 16px;
      }
    }
  }
`;

@observer
class NotificationIndexMemrev extends React.Component {

  isExternalLink = url => {
    if (!url) return false;
    return url.startsWith('http://') || url.startsWith('https://');
  };

  renderNotificationContent(item) {
    return (
      <>
        <ImageWrapper>
          {
            item.worksheet?.podcastEpisode?.podcast?.imageUrl ? (
              <IconCircle background={AppUI.site.accentColor}>
                <MicrophoneIcon fill='#FFF' />
              </IconCircle>
            ) : item.worksheet && !item.worksheet.podcastEpisode ? (
              <IconCircle background='#ed2021'>
                <YoutubeIcon fill='#FFF' />
              </IconCircle>
            ) : (item.primarySender || item.announcer) ? (
              <UserProfileImage
                user={item.primarySender || item.announcer}
                width={30}
                padding='0px'
              />
            ) : (
              <IconCircle background={AppUI.site.secondaryAccentColor}>
                <BellIcon fill='#FFF' />
              </IconCircle>
            )
          }
        </ImageWrapper>
        <MessageWrapper>
          <NotificationMessage
            notification={item}
          />
          <Text
            italic
            color='#777'
            fontSize='13px'
          >
            {item.createdAt && item.createdAt.relativeTime}
          </Text>
        </MessageWrapper>
      </>
    );
  }

  render() {
    return (
      <Wrapper>
        {
          isPresent(this.props.notifications) && this.props.notifications.map(item => {
            return (
              <Notification
                background={item.seen ? 'FFF' : '#edf2fa'}
                key={item.id}
              >
                {
                  this.isExternalLink(item.notificationLink) ? (
                    <a
                      href={item.notificationLink}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {this.renderNotificationContent(item)}
                    </a>
                  ) : (
                    <Link to={item.notificationLink}>
                      {this.renderNotificationContent(item)}
                    </Link>
                  )
                }
              </Notification>
            );
          })
        }
        {
          isPresent(this.props.notifications) &&
          <PaginatorWrapper>
            <Paginator
              compact
              onClickScrollToTop
              store={this.props.store}
            />
          </PaginatorWrapper>
        }
      </Wrapper>
    );
  }
}

export default NotificationIndexMemrev;
